var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { attrs: { bodyStyle: _vm.getBodyStyle } }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _c(
              "h5",
              {
                staticClass:
                  "sub-header-header typography--headline typography--color-secondary pl-10-mobile pr-10-mobile"
              },
              [_vm._v("\n          AI 데일리 퀴즈\n        ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 hidden-xs-down" }, [
            _c("div", { staticClass: "sub-header-btn-row float-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary new-quiz-button",
                  attrs: { disabled: _vm.isLoadingMyQuizzes },
                  on: { click: _vm.handleNewQuizClick }
                },
                [_vm._v("\n            AI 데일리 퀴즈 만들기\n          ")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 my-quizzes-wrapper",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.isLoadingMyQuizzes && _vm.isEmptyQuizzes
          ? _c("LoadingBounce", { staticClass: "loading" })
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.isEmptyQuizzes
                  ? _c("div", { staticClass: "no-quiz-wrapper" }, [
                      _vm._v(
                        "\n        지금 바로 AI 데일리 퀴즈를 만들어 보세요.\n      "
                      )
                    ])
                  : _vm._l(_vm.myQuizzes, function(quiz, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "col-lg-6 col-xs-12 quiz-wrapper"
                        },
                        [
                          _c("MyQuizCard", {
                            attrs: { quiz: quiz },
                            on: {
                              click: function($event) {
                                return _vm.handleQuizClick(quiz)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _vm.isInfiniteLoading
                  ? _c(
                      "InfiniteLoading",
                      {
                        ref: "infiniteLoading",
                        staticClass: "w-100",
                        attrs: { "on-infinite": _vm.onInfiniteMyQuizzes }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "spinner" }, slot: "spinner" },
                          [_c("LoadingBounce", { staticClass: "loading" })],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "no-results" },
                          slot: "no-results"
                        }),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "no-more" },
                          slot: "no-more"
                        })
                      ]
                    )
                  : _vm._e()
              ],
              2
            ),
        _vm._v(" "),
        _vm.isQuizFormModal
          ? _c("QuizFormModal", {
              attrs: { quiz: _vm.quiz },
              on: { cancel: _vm.handleModalCloseClick }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isQuizModal
          ? _c("MyQuizModal", {
              attrs: { quiz: _vm.quiz },
              on: {
                ok: _vm.handleQuizModalOkClick,
                cancel: _vm.handleQuizModalCancelClick
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a5412a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a5412a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-quizzes/views/MyQuizzes.vue
// module id = PyPT
// module chunks = 1